webpackJsonp([270481251263814],{

/***/ 373:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Apply":"src-components-Apply-Interest----Apply-module---Apply---dXkTH","Button":"src-components-Apply-Interest----Apply-module---Button---1LoWR"};

/***/ }),

/***/ 333:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(5);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _ApplyModule = __webpack_require__(373);
	
	var _ApplyModule2 = _interopRequireDefault(_ApplyModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ApplyInterest = function ApplyInterest(props) {
	  return _react2.default.createElement(
	    'div',
	    { className: _ApplyModule2.default.Apply },
	    _react2.default.createElement(
	      'h2',
	      { className: 'h2' },
	      props.title
	    ),
	    props.buttonTitle ? _react2.default.createElement(
	      'a',
	      { className: _ApplyModule2.default.Button, href: props.buttonUrl, target: '_blank' },
	      props.buttonTitle
	    ) : _react2.default.createElement(
	      _gatsbyLink2.default,
	      { to: '/interest-form/', className: _ApplyModule2.default.Button },
	      'Learn More'
	    )
	  );
	};
	
	exports.default = ApplyInterest;
	module.exports = exports['default'];

/***/ }),

/***/ 376:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Destinations":"src-components-Program-Destinations----Destinations-module---Destinations---1idFy","Cards":"src-components-Program-Destinations----Destinations-module---Cards---2GXFp","Card":"src-components-Program-Destinations----Destinations-module---Card---1R22p"};

/***/ }),

/***/ 340:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(5);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _gatsbyImage = __webpack_require__(22);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _DestinationsModule = __webpack_require__(376);
	
	var _DestinationsModule2 = _interopRequireDefault(_DestinationsModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Destinations = function Destinations(props) {
	  return _react2.default.createElement(
	    'div',
	    { className: _DestinationsModule2.default.Destinations, id: 'destinations' },
	    _react2.default.createElement(
	      'h2',
	      { className: 'h2' },
	      props.title
	    ),
	    _react2.default.createElement(
	      'p',
	      { className: 'p-large' },
	      props.text
	    ),
	    _react2.default.createElement(
	      _gatsbyLink2.default,
	      { to: props.link.link, className: 'button' },
	      props.link.text
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: _DestinationsModule2.default.Cards },
	      props.cards.map(function (card, i) {
	        return _react2.default.createElement(
	          'div',
	          { className: _DestinationsModule2.default.Card, key: i },
	          _react2.default.createElement(_gatsbyImage2.default, { sizes: card.featuredImage.sizes, alt: card.featuredImage.title }),
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { className: 'hoverlink', to: card.link.link },
	            card.link.text
	          )
	        );
	      })
	    )
	  );
	};
	
	exports.default = Destinations;
	module.exports = exports['default'];

/***/ }),

/***/ 614:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(6);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _gatsbyLink = __webpack_require__(5);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _CustomHelmet = __webpack_require__(7);
	
	var _CustomHelmet2 = _interopRequireDefault(_CustomHelmet);
	
	var _ApplyInterest = __webpack_require__(333);
	
	var _ApplyInterest2 = _interopRequireDefault(_ApplyInterest);
	
	var _Afterhero = __webpack_require__(292);
	
	var _Afterhero2 = _interopRequireDefault(_Afterhero);
	
	var _Destinations = __webpack_require__(340);
	
	var _Destinations2 = _interopRequireDefault(_Destinations);
	
	var _VimeoEmbed = __webpack_require__(117);
	
	var _VimeoEmbed2 = _interopRequireDefault(_VimeoEmbed);
	
	var _Hero = __webpack_require__(293);
	
	var _Hero2 = _interopRequireDefault(_Hero);
	
	var _Row = __webpack_require__(3);
	
	var _Row2 = _interopRequireDefault(_Row);
	
	var _Column = __webpack_require__(4);
	
	var _Column2 = _interopRequireDefault(_Column);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ScrollMagic;
	if (typeof window === 'object') {
	    ScrollMagic = __webpack_require__(24);
	}
	
	// if(typeof window == 'object') {
	// 	require('imports-loader?define=>false!scrollmagic/scrollmagic/uncompressed/plugins/debug.addIndicators.js')
	// }
	
	var ApprenticeshipTempTemplate = function (_React$Component) {
	    _inherits(ApprenticeshipTempTemplate, _React$Component);
	
	    function ApprenticeshipTempTemplate(props) {
	        _classCallCheck(this, ApprenticeshipTempTemplate);
	
	        var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	        _this.state = {
	            activeNav: '',
	            controller: null
	        };
	        return _this;
	    }
	
	    ApprenticeshipTempTemplate.prototype.componentDidMount = function componentDidMount() {};
	
	    ApprenticeshipTempTemplate.prototype.componentWillUnmount = function componentWillUnmount() {};
	
	    ApprenticeshipTempTemplate.prototype.render = function render() {
	        var page = this.props.data.page;
	
	        var seoKeywords = page.seoData.keywords ? page.seoData.keywords.toString() : '';
	        var pageData = this.props.pathContext.data;
	
	        return _react2.default.createElement(
	            'div',
	            { className: 'apprenticeship' },
	            _react2.default.createElement(_CustomHelmet2.default, { data: page.seoData }),
	            _react2.default.createElement(_Hero2.default, {
	                title: pageData.introTitle,
	                src: pageData.heroImage
	            }),
	            _react2.default.createElement(_Afterhero2.default, {
	                text: pageData.introduction.internal.content
	            }),
	            pageData.pastStories && pageData.pastStories.map(function (story, index) {
	                return _react2.default.createElement(
	                    _Row2.default,
	                    { className: 'example' + (index > 0 ? ' no-padding-top' : ''), key: index },
	                    _react2.default.createElement(
	                        _Column2.default,
	                        { width: '12', className: 'capped' },
	                        story.fellowHeadshot && story.fellowHeadshot.file.url && _react2.default.createElement('img', { src: story.fellowHeadshot.file.url, alt: '', className: 'fellow-headshot' }),
	                        story.videoUrl && _react2.default.createElement(
	                            _Row2.default,
	                            { className: 'no-padding' },
	                            _react2.default.createElement(
	                                _Column2.default,
	                                { width: '4', tablet: '12', className: 'details' },
	                                _react2.default.createElement(
	                                    'h3',
	                                    null,
	                                    story.fellowDetail
	                                )
	                            ),
	                            _react2.default.createElement(
	                                _Column2.default,
	                                { width: '7', offsetL: '1', tablet: '12', className: 'quote' },
	                                _react2.default.createElement(_VimeoEmbed2.default, {
	                                    poster: story.videoPosterImage,
	                                    url: story.videoUrl,
	                                    loop: false,
	                                    autoplay: false,
	                                    controls: true
	                                })
	                            )
	                        ),
	                        !story.videoUrl && _react2.default.createElement(
	                            _Row2.default,
	                            { className: 'no-padding' },
	                            _react2.default.createElement(
	                                _Column2.default,
	                                { width: '6', tablet: '12', className: 'details' },
	                                _react2.default.createElement(
	                                    'h3',
	                                    null,
	                                    story.fellowDetail
	                                )
	                            ),
	                            _react2.default.createElement(
	                                _Column2.default,
	                                { width: '6', tablet: '12', className: 'quote' },
	                                _react2.default.createElement(
	                                    'p',
	                                    null,
	                                    story.fellowQuote.fellowQuote
	                                )
	                            ),
	                            _react2.default.createElement(
	                                _Column2.default,
	                                { width: '12', className: 'link' },
	                                _react2.default.createElement(
	                                    'a',
	                                    { href: story.link.link, className: 'hoverlink', target: '_blank' },
	                                    story.linkText
	                                )
	                            )
	                        )
	                    ),
	                    index == 1 && _react2.default.createElement(
	                        'div',
	                        { className: 'strokes' },
	                        _react2.default.createElement('img', { className: 'Strokes__Blue', src: '/images/blue-strokes.png', alt: 'Blue stroke' })
	                    )
	                );
	            }),
	            _react2.default.createElement(_ApplyInterest2.default, {
	                title: page.applyTitle
	            })
	        );
	    };
	
	    return ApprenticeshipTempTemplate;
	}(_react2.default.Component);
	
	exports.default = ApprenticeshipTempTemplate;
	var query = exports.query = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-apprenticeship-js-82ab06344b527891d8f0.js